import './datepicker.scss';

import { useRef, useState } from 'react';
import { PTextFieldWrapper } from "@porsche-design-system/components-react";

import "react-datepicker/dist/react-datepicker.css";

export interface IDatepickerProps {
    placeholder: string;
    value?: string,
    className?: string,
    label?: string,
    onChange?: (value: string) => void;
    disabled?: boolean;
    isError?: boolean;
    errorMsg?: string;
    id? : string;
}

const Datepicker = (props: IDatepickerProps) => {
    const inputRef = useRef(null);
    const [value, setValue] = useState("");
    const fieldValue = props.value !== undefined ? props.value : value

    return (
        <PTextFieldWrapper label={props.label}
            state={props.isError === true ? "error" : "none"}  autoFocus={false} inert={false}>
            <input
              ref={inputRef}
              autoFocus={false}
              inert={false}
              id={props.id}
              value={fieldValue}
              placeholder={props.placeholder}
              className={props.isError === false ? "text-field-input" : "ext-field-input error-input"}
              type="date"
              disabled={props.disabled}
              onChange={(e) => {
                  const inputValue = e.target.value;
                  props.onChange && props.onChange(inputValue);
                  setValue(inputValue);
              }}
            />
            <span slot="message" id="some-message-id" className="validation-message">{props.errorMsg}</span>
        </PTextFieldWrapper>
    )
};
export default Datepicker;
